export default __webpack_public_path__ + "static/media/Lock.13da8e22.svg";